import { render, staticRenderFns } from "./CustomerTagsForm.vue?vue&type=template&id=473af75f&"
import script from "./CustomerTagsForm.vue?vue&type=script&lang=js&"
export * from "./CustomerTagsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports